import { sendEmailOfficeSettings } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailOfficeSettings);
};
export default useSendEmail;
